module.exports = __webpack_public_path__ + "static/flags/FJ-3d60b2bdc134433c70ef3d89f4e9604b.gif";